export const productLink = 'https://store.minet.jp/item/8025.html?utm_source=360web&utm_medium=productlink';
